import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import DownloadCenter from '../components/DownloadCenter'
import Helmet from 'react-helmet'
import { useLocation } from '@reach/router'

const Downloads = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const navBarData = data.contentfulNavigationBar
  const footerData = data.contentfulFooterV2
  const siteLanguages = data.site.siteMetadata.languages
  const downloadData = [
    data.allContentfulDownloadCenterItem,
    data.allContentfulAlertBar,
    data.allContentfulDownloadCenterTooltip,
    data.allContentfulDownloadCenterHardwareFirmware,
    data.contentfulPageBlock,
  ]
  const latestBlogPost = data.latestPost.edges[0].node
  const location = useLocation()
  return (
    <Layout
      latestBlogPost={latestBlogPost}
      navBarData={navBarData}
      footerData={footerData}
      siteLanguages={siteLanguages}
      location={location}
    >
      <div style={{ background: '#fff' }}>
        <Helmet title={siteTitle} />
        <DownloadCenter data={downloadData} />
      </div>
    </Layout>
  )
}

export default Downloads

export const pageQuery = graphql`
  {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    latestPost: allWpPost(
      sort: { fields: date, order: DESC }
      limit: 1
      filter: { locale: { locale: { eq: "en_US" } }, status: { eq: "publish" } }
    ) {
      edges {
        node {
          ...LatestPost
        }
      }
    }

    contentfulNavigationBar(node_locale: { eq: "en-US" }) {
      ...ContentfulNavQuery
    }

    contentfulFooterV2(node_locale: { eq: "en-US" }) {
      ...ContentfulFooterQuery
    }

    contentfulPageBlock(
      contentful_id: { eq: "tMU2cDR8gvNpXiRuZuHRq" }
      node_locale: { eq: "en-US" }
    ) {
      title
      page {
        slug
      }
      blockVisibility
      subtitle {
        subtitle
        childMarkdownRemark {
          html
        }
      }
      hideTitle
      images {
        fluid(
          maxWidth: 1900
          maxHeight: 821
          quality: 100
          background: "rgb:000000"
        ) {
          ...GatsbyContentfulFluid_withWebp
        }
        fixed {
          src
        }
        description
      }
      order
      type
      ctaText
      ctaUrl
      video_ref {
        title
        videoId
        videoPlaylistId
        videoUrl
        backgroundImage {
          fixed(width: 1304, height: 733) {
            src
          }
          description
        }
      }
      contactForm_ref {
        portalId
        formId
        loadingText
        webinarKey
      }
      spacer_ref {
        backgroundColor
        includeHorizontalRule
        useOusterGradient
        horizontalRuleColor
        horizontalRuleHeight
        height
        mobileHeight
        displayOnMobile
      }
      components {
        title
        subtitle {
          subtitle
          childMarkdownRemark {
            html
          }
        }
        superHeader
        order
        image {
          description
          fixed(width: 1800, quality: 75) {
            src
          }
          fluid(
            maxWidth: 1900
            maxHeight: 1221
            quality: 100
            background: "rgb:000000"
          ) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        secondaryImages {
          fluid(
            maxWidth: 1900
            maxHeight: 1221
            quality: 100
            background: "rgb:000000"
          ) {
            ...GatsbyContentfulFluid_withWebp
          }
          description
        }
        link
        sentenceList
        ctaText
        ctaUrl
      }
    }

    allContentfulDownloadCenterItem(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          title
          node_locale
          groupType {
            groupType
            id
            order
          }
          downloadCenterTableData {
            tableData
            id
          }
          order
        }
      }
    }

    allContentfulAlertBar(
      filter: { node_locale: { eq: "en-US" }, type: { eq: "Download Center" } }
    ) {
      edges {
        node {
          id
          linkUrl
          mobileText
          text
          type
        }
      }
    }

    allContentfulDownloadCenterTooltip(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          id
          tooltipText
          tooltipLink
          tooltipButtonText
          node_locale
        }
      }
    }

    allContentfulDownloadCenterHardwareFirmware(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          type
          label
          value
          order
          incompatible {
            value
          }
          downloadAlertText
          node_locale
        }
      }
    }
  }
`
